import { Button } from "@material-ui/core"
import React from "react"
import { NavLink } from "react-router-dom"
import { useQueryUserTrainings } from "../../data"
import { useAuth } from "../../services"
import { toId } from "../../utils"
import { RowBox } from "../Boxes"
import { Icon } from "../Icon"

const DesktopTrainingButton = () => {
  const {
    principal: { userID: user },
  } = useAuth()
  const { data } = useQueryUserTrainings({ variables: { user } })

  const uncompletedUserTraining = data?.userTrainings.find((userTraining) => !userTraining.status.completedAt)
  if (!uncompletedUserTraining) {
    return null
  }

  return (
    <Button component={NavLink} variant="contained" to={`/knowledge/training/${toId(uncompletedUserTraining)}`}>
      <RowBox>
        <Icon name="training" style={{ marginRight: 8 }} />
        Your Training
      </RowBox>
    </Button>
  )
}

export { DesktopTrainingButton }
